import { render, staticRenderFns } from "./Privacy_202609.vue?vue&type=template&id=132ce178&scoped=true"
import script from "./Privacy_202609.vue?vue&type=script&lang=js"
export * from "./Privacy_202609.vue?vue&type=script&lang=js"
import style0 from "@/assets/help/document.css?vue&type=style&index=0&id=132ce178&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132ce178",
  null
  
)

export default component.exports